import api from '../api';

// Loads Yandex Maps JS API v3 (https://yandex.ru/maps-api/docs/js-api/common/quickstart.html).
// The API key itself lives on the backend (Yandex:MapsApiKey) and is fetched once via /mapconfig,
// so nobody has to hardcode it in the frontend build.
let loadPromise = null;
let cdnRegistered = false;

// Optional ymaps3 packages have no built-in loader — must be registered against a CDN
// before ymaps3.import() can resolve them, otherwise it throws "no loader for pkg ...".
function registerYmapsCdnPackages(ymaps3) {
    if (cdnRegistered) return;
    cdnRegistered = true;
    ymaps3.import.registerCdn('https://cdn.jsdelivr.net/npm/{package}', [
        '@yandex/ymaps3-clusterer@latest',
        '@yandex/ymaps3-controls@latest',
    ]);
}

export function loadYmaps() {
    if (window.ymaps3) return Promise.resolve(window.ymaps3);
    if (loadPromise) return loadPromise;

    loadPromise = api.get('/mapconfig')
        .then(({ data }) => {
            const apiKey = data?.mapsApiKey;
            if (!apiKey) {
                throw new Error('Yandex Maps API key is not configured on the backend (Yandex:MapsApiKey in appsettings.json)');
            }
            return new Promise((resolve, reject) => {
                const existing = document.querySelector('script[data-ymaps3]');
                if (existing) {
                    existing.addEventListener('load', () => window.ymaps3.ready.then(() => { registerYmapsCdnPackages(window.ymaps3); resolve(window.ymaps3); }));
                    existing.addEventListener('error', () => reject(new Error('Failed to load Yandex Maps script')));
                    return;
                }
                const script = document.createElement('script');
                script.src = `https://api-maps.yandex.ru/v3/?apikey=${apiKey}&lang=ru_RU`;
                script.async = true;
                script.dataset.ymaps3 = 'true';
                script.onload = () => {
                    window.ymaps3.ready.then(() => { registerYmapsCdnPackages(window.ymaps3); resolve(window.ymaps3); }).catch(reject);
                };
                script.onerror = () => reject(new Error('Failed to load Yandex Maps script'));
                document.head.appendChild(script);
            });
        })
        .catch(err => {
            loadPromise = null; // allow retrying (e.g. after the key is pasted in appsettings)
            throw err;
        });

    return loadPromise;
}

// Dynamically imports an optional ymaps3 package, e.g. '@yandex/ymaps3-clusterer' or '@yandex/ymaps3-controls'.
export async function importYmapsModule(name) {
    const ymaps3 = await loadYmaps();
    return ymaps3.import(name);
}
